import React, { useState } from 'react'
import Image from 'next/image'
import { SendbirdUserResponse } from '../../types/sendbird/response/sendbird-user-response'
import { RequestResponse } from '../../types/requests/responses/request-response'
import MiniIcon from '../../public/static/minimize.svg'
import { parseUsers } from '../../common/utils/lobby.utils'
import { useUser } from '../../hooks/users/useUser'
import MessagesSection from '../message/MessagesSection'
import DiscordSection from '../discord/DiscordSection'
import { isNil } from '../../common/utils/common.utils'

type Props = {
  request: RequestResponse
  user: SendbirdUserResponse
  size?: 'base' | 'large'
  isTeammate?: boolean
}

const ChatArea = ({
  request,
  user,
  size = 'base',
  isTeammate = false,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const { user: currentUser } = useUser()
  const users = parseUsers(request?.lobby?.userLobby)?.filter((customer) => {
    return customer?.id !== currentUser?.id
  })
  const { user: customer } = useUser()

  if (isNil(request.lobby?.sendbirdRoom?.chatChannelUrl)) {
    return null
  }

  return (
    <div
      className={`w-full  ${
        size === 'base' ? 'rounded-t-lg' : 'rounded-lg'
      }  opacity-97 shadow-2xl ${
        size === 'base' ? 'sm:w-96' : 'md:w-96 lg:w-128'
      } flex flex-col`}
    >
      {!isOpen && (
        <div className={'hidden md:flex mb-2.5'}>
          <DiscordSection isTeammate={isTeammate} />
        </div>
      )}

      <div
        className={`relative rounded-t-xl ${
          size === 'base'
            ? isOpen
              ? 'hidden max-h-0 overflow-hidden'
              : 'displayElement'
            : ''
        } ${
          size === 'large'
            ? isOpen
              ? 'hidden max-h-0 overflow-hidden md:flex md:max-h-none md:overflow-auto'
              : 'displayElement'
            : ''
        }`}
      >
        <MessagesSection
          request={request}
          user={user}
          chatChannelUrl={request.lobby?.sendbirdRoom?.chatChannelUrl!}
          size={size}
          customer={customer}
        />

        <div
          className={`absolute left-0 top-0 flex h-15 w-full items-center justify-end px-4 ${
            size === 'large' ? 'flex md:hidden' : 'flex '
          }`}
        >
          <Image
            onClick={() => {
              setIsOpen(!isOpen)
            }}
            className={'cursor-pointer'}
            src={MiniIcon}
            width={24}
            height={24}
            alt={'Minimize icon'}
          />
        </div>
      </div>

      <div
        className={`flex h-14 w-full flex-row bg-fizz-700 items-center justify-center rounded-t-xl px-5 lg:w-88 ${
          size === 'base' ? (isOpen ? 'displayElement' : 'hiddenElement') : ''
        } ${
          size === 'large'
            ? isOpen
              ? 'displayElement md:hidden'
              : 'hiddenElement'
            : ''
        }`}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        <div className={'flex w-full flex-row items-center'}>
          <div className={'relative h-8 w-8 shrink-0 rounded-full'}>
            <Image
              src={
                users[0]?.avatar?.imageUrl ??
                process.env.NEXT_PUBLIC_DEFAULT_AVATAR_URL!
              }
              className={'rounded-full object-cover'}
              fill={true}
              alt={'User avatar'}
            />
          </div>

          <p className={'text-color-gray5 text-body-normal ml-3 w-40 truncate'}>
            {users
              ?.map((user) => {
                return user?.username ?? user?.fullName ?? ''
              })
              ?.join(',')}
          </p>
        </div>
      </div>

      {!isOpen && (
        <div className={'flex md:hidden -mt-5'}>
          <DiscordSection isTeammate={isTeammate} />
        </div>
      )}
    </div>
  )
}

export default ChatArea
